import styled from 'styled-components';
import { Caption, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { MessageContainer } from 'modules/templateEditor/EditEmbedded/preview/styles';
import { pxToRem } from 'utils/convert';

export const StyledMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: ${spacing.double};

  ${MessageContainer} {
    width: ${pxToRem(268)};
    margin: auto;
  }
`;

export const StyledCarouselSelector = styled.div`
  display: grid;
  margin: auto;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  gap: ${spacing.quarter};
`;

export const EllipsisColumn = styled.div`
  grid-column-start: 2;
  grid-column-end: 2;

  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: ${spacing.quarter};
`;

export const EmptyPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${pxToRem(178)};
`;

export const RightArrowColumn = styled.div`
  grid-column-start: 3;
  grid-column-end: 3;
  padding-top: ${spacing.eighth};
`;

export const LeftArrowColumn = styled.div`
  grid-column-start: 1;
  grid-column-end: 1;
  padding-top: ${spacing.eighth};
  gap: ${spacing.threeEights};
`;

export const StyledPreviewSkeleton = styled.div`
  height: ${pxToRem(160)};
  width: ${pxToRem(268)};
  border-radius: ${spacing.half};
  margin: auto;
`;

export const StyledTooltip = styled(Tooltip)`
  margin: auto;
  width: ${pxToRem(268)};
  display: flex;
  justify-content: center;
`;

export const StyledCaption = styled(Caption)`
  text-align: center;
`;
